import { render, staticRenderFns } from "./AddProjectLogoDialog.vue?vue&type=template&id=23f58604"
import script from "./AddProjectLogoDialog.vue?vue&type=script&lang=js"
export * from "./AddProjectLogoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports